export default class Lockout {

	static top: number = 0;

	static on() {
		Lockout.top = document.documentElement.scrollTop;
		document.documentElement.classList.add('html--lockout');
		document.body.style.marginTop = '-' + Lockout.top + 'px';
	}

	static off() {
		document.documentElement.classList.remove('html--lockout');
		document.body.style.removeProperty('margin');
		window.scroll(0, Lockout.top);
	}


}

